import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const mutation = graphql`
  mutation SignJobContractMutation($input: SignJobContractInput!) {
    signJobContract(input: $input) {
      job {
        id
        status
        contract {
          id
          contractId
          dateSignedByOrganization
          dateSignedByContractor
          signedPdfByContractorUrl
          signedPdfByOrganizationUrl
          finalizedPdfUrl
          template {
            name
          }
        }
      }
      emailSent
    }
  }
`;

export default (jobId, signatureImage, contractDate, callback) => {
  commitMutation(getEnvironment(), {
    mutation,
    variables: { 
      input: { 
        jobId,
        contractDate
      } 
    },
    uploadables: { signature_image: signatureImage },
    onCompleted: response => {
      callback(response.signJobContract);
    },
    onError: err => console.error(err)
  });
};
